import React from 'react'
import '../style/style.css'
import {motion} from 'framer-motion'  

export default function Contact() { 
    return (
     <motion.div 
        initial={{opacity:0, y:"-100%"}} 
        animate={{opacity:1, y:0}} 
        exit={{opacity:0, y:"-100%"}}
        transition={{type:"spring"}} 
        className="col-lg-9 col-md-9 col-sm-9 col-xs-12">

        <div className="container">
         <center>
         <div style={{width:'80%' , margin:'0 auto' , fontSize:'20px'}}>
               <h1 style={{fontFamily: 'Dancing Script, cursive'}}>Feel free to contact </h1>
               <p>Address : Lohardaga Jharkhand 835308 </p> 
               <p>Email : ritikadey7890@gmail.com</p> <br/> 
            
               <div className="d-inline-block">
               <a href="https://m.facebook.com/ritika.dey.3785373" target="blank" className="fa fa-facebook"/>
               <a href="https://www.instagram.com/_ritika_dey/" target="blank" className="fa fa-instagram"/>
               <a href="https://www.linkedin.com/in/ritika-dey/" target="blank" className="fa fa-linkedin"/>
               <a href="https://github.com/Ritika-dey" target="blank" className="fa fa-github"/> 
               </div>
            </div>
         </center>
         </div>
      </motion.div>
    )
}
